import { call, put, select } from 'redux-saga/effects';
import { api, showSuccessNotification, showErrorNotification } from '@med-fe/util';
import {
  fetchResourceCleanupDetailsSuccess,
  fetchResourceCleanupDetailsFailed,
  validateFileSuccess,
  validateFileFailed,
  processCleanupSuccess,
  processCleanupFailed,
  updateProcessCleanupResponse,
  fetchResourceFileDetailsSuccess,
  fetchResourceFileDetailsFailed,
  downloadFileSuccess,
  downloadFileFailed,
  deleteFileSuccess,
  deleteFileFailed,
  fetchResourceCleanupDetails,
} from './resources-action';

export function* getResourcesStartWorker({ payload }): Generator {
  try {
    const url = `/resourcecleanup`;
    const data = yield call(api.get, url);
    yield put(fetchResourceCleanupDetailsSuccess(data));
  } catch (e) {
    yield put(fetchResourceCleanupDetailsFailed(e));
    showErrorNotification();
  }
}

export function* validateFileStartWorker({ payload }: any): Generator {
  try {
    const maxSize = 100000; // according to BE implementation
    let search = {};
    const data = yield call(
      api.downloadFile,
      '/resourcecleanup/validate?type=' + payload,
      {
        ...search,
        page: 0,
        size: maxSize,
        type: payload.type,
        fileName: payload.toLowerCase(),
      },
      'GET'
    );
    if (data && !data.success) {
      yield put(validateFileFailed());
      showErrorNotification(data.error || 'File validation failed.');
      return;
    }
    showSuccessNotification('File successfully generated');
    yield put(validateFileSuccess());
  } catch (e) {
    yield put(validateFileFailed());
    showErrorNotification();
  }
}

export function* processCleanupStartWorker({ payload }): Generator {
  try {
    const url = `/resourcecleanup/process/${payload}`;
    const data = yield call(api.post, url, payload);
    yield put(processCleanupSuccess());
    yield put(updateProcessCleanupResponse(data));
    yield put(fetchResourceCleanupDetails(''));
  } catch (e) {
    yield put(processCleanupFailed());
    showErrorNotification();
  }
}

export function* resourceFileDetailsStartWorker({ payload }): Generator {
  try {
    const url = `/resourcecleanup/viewData`;
    const data = yield call(api.get, url);
    yield put(fetchResourceFileDetailsSuccess(data));
  } catch (e) {
    yield put(fetchResourceFileDetailsFailed(e));
    showErrorNotification();
  }
}

export function* downloadFileStartWorker({ payload }: any): Generator {
  try {
    yield call(api.downloadResourceFile, '/resourcecleanup/download', payload, 'POST');
    yield put(downloadFileSuccess());
  } catch (e) {
    yield put(downloadFileFailed());
    showErrorNotification();
  }
}

export function* deleteResourceStartWorker({ payload }): Generator {
  try {
    const url = `/resourcecleanup/delete/${payload}`;
    const data = yield call(api.delete, url);
    yield put(deleteFileSuccess());
    showSuccessNotification('File deleted successfully');
    yield put(fetchResourceCleanupDetails(''));
  } catch (e) {
    yield put(deleteFileFailed());
    showErrorNotification();
  }
}
